<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.ViewHistory')"
    width="600px"
    :close-on-click-modal="false"
    class="app-main-inner edi-show-history"
  >
    <div class="app-main-inner-row row-grid-dialog" style="padding-top: 0;">
      <cargo-ag-grid
        :show-side-bar="false"
        :grid-params.sync="gridParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width: 100%;"
      />
    </div>
  </el-dialog>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'ShowHistoryDialog',
  props: {
    visible: { type: Boolean, required: true },
    params: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: false,
      rowData: [],
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false
      },
      isXy: false
    }
  },
  computed: {
    columnDefs() {
      return [{
        headerName: this.$t('SeaExport.FileType2'),
        field: 'type',
        width: 80,
        cellRenderer: params => {
          return ColumnUtils.ediTypeLabelFunc(this.isXy, params.data)
        }
      }, {
        headerName: this.$t('Payment.status'),
        field: 'status',
        width: 110,
        cellRenderer: params => {
          return ColumnUtils.ediStateLabelFunc(this.isXy, params.data)
        }
      }, {
        headerName: this.$t('SeaExport.ExportTime'),
        field: 'outputDate',
        width: 180
      }, {
        headerName: this.$t('SeaExport.ReturnInformation'),
        field: 'returnMessage',
        width: 180
      }
      ]
    }
  },
  watch: {
    visible(newVal, oldVal) {
      this.innerVisible = newVal
      this.rowData = this.params.data
    },
    innerVisible(newVal, oldVal) {
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    await cache.load(cacheName.OFFICE, cacheName.CONFIG)
    this.isXy = String(cache.config.get('ToExoSystem')) === 'XY'
  }
}
</script>

<style lang="scss">
.edi-show-history {
  .el-dialog__body {
    padding: 0 !important;
  }
}
</style>
